import {
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tab,
  Tabs,
  TextField,
  Typography,
  Link,
  ListItemIcon,
  CircularProgress,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  styled,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import React, { useCallback, useEffect, useRef, useState } from "react";
import PersonIcon from "@mui/icons-material/Person";
import { Margin, Padding } from "@mui/icons-material";
import Swal from "sweetalert2";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DetailDocPending from "./DetailDocPending";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import personimage from "../../../../Image/image.png";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
// import DocumentSequenceDialog from "./SignSignatureDialog";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import ApartmentIcon from "@mui/icons-material/Apartment";
import Approveimage from "../../../../Image/approve.png";
import Attachmentsimage from "../../../../Image/attachments.png";
import no_documents from "../../../../Image/no_documents.png";
import icon_pdf from "../../../../Image/icon_pdf.png";
import logo_del from "../../../../Image/logo_del.png";
import icon_import from "../../../../Image/icon_import.png";
import icon_hospital from "../../../../Image/icon_hospital.png";
import Autocomplete from "@mui/material/Autocomplete";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { PDF_example, PDF_example3page } from "../DocumentPersonalComponent/Base64";
import icon_doc from "../../../../Image/icon_doc.png";
import DescriptionIcon from "@mui/icons-material/Description";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useHistory, useLocation } from "react-router-dom";
import ErroPagerPDF from "../DocumentPersonalComponent/ErroPagerPDF";
import BadgeIcon from "@mui/icons-material/Badge";
// import SignSignatureDialog from "./SignSignatureDialog";
// import SignatureDrawing from "./SignatureDrawing";
// import DialogAttachDocPDF from "./DialogAttachDocPDF";
import LoadingIndicator from "../PersonalDataAgreementComponent/Loading/LoadingIndicator";
import {
  APIEndpointWeb,
  webapi,
  GetLocalStorageAccessToken,
  GetLocalStorageData,
  GetLocalStorageOrganization,
} from "../../../../client/web";

const top100Films = [
  { title: "The Shawshank Redemption", year: 1994 },
  { title: "The Godfather", year: 1972 },
  { title: "The Godfather: Part II", year: 1974 },
  { title: "The Dark Knight", year: 2008 },
  { title: "12 Angry Men", year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: "Pulp Fiction", year: 1994 },
];

const prefix = [
  { prefix: 'นาย', gender: 'นาย' },
  { prefix: 'นาง', gender: 'นาง' },
  { prefix: 'นางสาว', gender: 'นางสาว' },
];

interface Film {
  title: string;
  year: number;
}


export interface PPHOMember {
  account_id: string,
  prefix: string,
  name: string,
  cid: string,
  position: string,
  email: string
}

interface Prefix {
  prefix: string;
  gender: string;
}

interface PdfArray {
  type: string;
  pdf_base64: string;
}

interface SeleteItem {
  name: string;
  value: string;
}

interface FileBase64 {
  name: string;
  base64: any;
}

interface getFileInterface {
  files_name: string;
  _id: string;
}
interface LocationState {
  document_no: any;
  message?: string;
  datadetail: any;
  // document_list: any[];
  dataform: any;
}

export interface IResultDetail {
  hoode: string;
  hname: string;
  document_no: string;
  provider_id: string;
  one_id: string;
  cid: string;
  กame: string;
  email: string;
  status_user: string;
  priority: string;
  document_list: IResultDetailDocument_list[];
  attachment: null;
  approve_list: IResultDetaiApprove_list;
}

export interface IResultDetailDocument_list {
  type: string;
  pdf_base64: string;
  document_json_id: string;
  document_json_name: string;
  pdf_link_download: string;
}

export interface IResultDetaiApprove_list {
  priority: number;
  provider_id: string;
  one_id: string;
  cid: string;
  prefix: string;
  กame: string;
  email: string;
  position: string;
  comment: string;
  status: string;
  update_time: string;
  reason: string;
}


const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

const IndexPendingDocument = () => {
  const [valueTab, setValueTab] = useState("1");
  const [resetInputPDF, setResetInputPDF] = useState<string>("");
  const [PDFUrl, setPDFUrl] = useState<string>("");
  const [selectedFiles, setSelectedFiles] = useState<FileBase64[]>([]);
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<Film[]>([]);
  const [optionsPPHOMember, setOptionsPPHOMember] = useState<PPHOMember[]>([]);
  const [loadingAutocomplete, setLoadingAutocomplete] = useState(false);
  const [inputValueAutocomplete, setInputValueAutocomplete] = useState("");
  const [inputValuePrefix, setInputValuePrefix] = useState("");
  const [optionsPrefix, setOptionsPrefix] = useState<Prefix[]>([]);
  const [openPrefix, setOpenPrefix] = useState(false);
  const [loadingPrefix, setLoadingPrefix] = useState(false);
  const history = useHistory();
  const [selectDoc, setSelectDoc] = useState("");
  const [scale, setScale] = useState<number>(0.6);
  const [scaleForReset, setScaleForReset] = useState<number>(0.6);
  const [errorPDF, setErrorPDF] = useState<string>("");
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [cid, setCid] = useState<string>("");
  const [nameData, setNameData] = useState<string>("");
  const [error, setError] = useState(false);
  const [checkReject, setCheckReject] = useState<boolean>(false);
  //////////////////////////////////////////////////////////////////////////////////////
  const [arrrayOfPdf, setArrrayOfPdf] = useState<PdfArray[]>([]);
  const [valuePdf, setvaluePdf] = useState<PdfArray>({
    type: "",
    pdf_base64: "",

  });
  const [arrrayOfSelete, setArrrayOfSelete] = useState<SeleteItem[]>([]);

  const [getFiles, setGetFiles] = useState<getFileInterface[]>([]);
  const [accessToken, setAccessToken] = useState<string>(
    GetLocalStorageAccessToken()
  );
  const [base64OfSign, setBase64OfSign] = useState<string>("");

  const [loading, setLoading] = useState<boolean>(false);
  const [selectedValue, setSelectedValue] = useState("นาย");
  // const [state, setState] = useState<LocationState>({
  //   message: "",
  //   datadetail: {}, // ป้องกัน undefined
  //   dataform: {},
  // });
  ////////////////////////////////////////////////////////////////////////
  const [openSecondDialog, setOpenSecondDialog] = useState(false);
  const [openAttachDoc, setOpenAttachDoc] = useState<boolean>(false);

  const location = useLocation<LocationState>();
  const messageDetail = location.state?.message;

  const viewerRef = useRef(null);

  const hiddenFileInputCreatePDF = useRef<HTMLInputElement>(null);
  const [resultDetail, setResultDetail] = useState<IResultDetail>({} as IResultDetail);
  const [localStorageData, setLocalStorageData] = useState<any>(null);
  const [localStorageOrganization, setLocalStorageOrganization] = useState<any>(null);
  const [checkPage234, setCheckPage234] = useState<string | null>("");


  const dataPageForm = location.state || {};
  const datadetail = location.state || {};

  useEffect(() => {
    getDetail()
    let params = new URLSearchParams(document.location.search);
    let page = params.get("page");
    setCheckPage234(page)
  }, [])


  const getDetail = async () => {
    try {
      setLoading(true)
      var { data } = await webapi.get(`${APIEndpointWeb.GetdetailDocument}=${datadetail.datadetail?.document_no}&priority=${dataPageForm.datadetail?.priority}&access_token=${accessToken}`,
        // var { data } = await webapi.get(`${APIEndpointWeb.GetdetailDocument}=2025-02-25-00007-00219-dsa&priority=${dataPageForm.datadetail?.priority}&access_token=${accessToken}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      if (data.result) {
        let dataArray = data.result?.approve_list.sort((a: any, b: any) => a.priority - b.priority)
        var index = dataArray.findIndex((x:any) => x.status  === "reject");
        if (index !== -1) {
          setCheckReject(true)
          // var arrayMock = []
             for (var indexOfFor in dataArray) {
                if (Number(indexOfFor) > index) {
                  dataArray[indexOfFor].status = ""
                }
             }
            //  console.log(dataArray, dataArray)
             data.result.approve_list = dataArray
        } else {
          data.result.approve_list = dataArray
        }
        // console.log("index", index)
        // console.log("dataArray", dataArray)
        setResultDetail(data.result ? data.result : {} as IResultDetail)
      } else {
        setResultDetail({} as IResultDetail)
      }
      setLoading(false)
    } catch (error :any) {
      setLoading(false)
      console.log(error)
      try{
        Swal.fire({
                title: error.response.data.status_result.status_message_th,
                icon: "error",
                  });
            } catch (error) {
              Swal.fire({
                title: "ไม่พบข้อมูล",
                icon: "error",
              });
            }
            
    }
  }


  useEffect(() => {
    if (!open) {
      setOptions([]);
      return;
    }

    setLoadingAutocomplete(true);
    sleep(1000).then(() => {
      setLoadingAutocomplete(false);
      // setOptions(top100Films);
    });
  }, [open]);


  useEffect(() => {
    if (!openPrefix) {
      setOptions([]);
      return;
    }
    setLoadingPrefix(true);
    sleep(500).then(() => {
      setLoadingPrefix(false);
      // setOptionsPrefix(prefix);
    });
  }, [openPrefix]);


  useEffect(() => {
    // console.log('resultDetail.document_list :>> ', resultDetail);
    if (resultDetail.document_list) {
      let array_empty: PdfArray[] = [];
      let array_selete: SeleteItem[] = [];
      for (let index = 0; index < resultDetail.document_list.length; index++) {
        if (index === 0) {
          setvaluePdf({
            type: resultDetail?.document_list[index].type,
            pdf_base64: resultDetail.document_list[index].pdf_base64,
          }); /// set ค่าเริ่มต้น
          setSelectDoc(resultDetail?.document_list[index].type); /// set ค่าเริ่มต้น
        }
        array_selete.push({
          name: resultDetail.document_list[index].type,
          value: resultDetail.document_list[index].type,
        });
        array_empty.push({
          type: resultDetail.document_list[index].type,
          pdf_base64: resultDetail.document_list[index].pdf_base64,
        });
      }
      // getFilesPDF();
      setArrrayOfSelete(array_selete);
      // console.log('array_selete :>> ', array_selete);
      setArrrayOfPdf(array_empty);


      let glsd = GetLocalStorageData()
      setLocalStorageData(glsd)

      let glso = GetLocalStorageOrganization()
      setLocalStorageOrganization(glso)

      getSignatureByProvider(glsd)
    } else {
      // history.push("/form-personal");
    }
    /////////////////////////////////////////////////////////////////////////////////
    const container: any = viewerRef.current;
    if (container) {
      const handleResize = () => {
        const newScale = container.clientWidth / 1012; // 612 is the default width of the page in points
        setScale(newScale);
        setScaleForReset(newScale);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, [resultDetail]);

  // const getFilesPDF = async () => {
  //   try {
  //     setLoading(true);
  //     var datax = {
  //       account_id: dataPageForm.dataform.one_id,
  //       hcode: dataPageForm.dataform.hcode,
  //     };
  //     var { data } = await webapi.post(
  //       `${APIEndpointWeb.PostGetListfilesPDF}`,
  //       datax,
  //       {
  //         headers: { Authorization: `Bearer ${accessToken}` },
  //       }
  //     );
  //     setGetFiles(data.result && data.result.length > 0 ? data.result : []);
  //   } catch (error) {
  //     setGetFiles([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const getSignatureByProvider = async (dataProp: any) => {
    try {
      //  setLoading(true);
      // var datax = {
      //   account_id: dataProp.data.account_id,
      //   cid: dataProp.data.full_cid,
      //   priority: Number(resultDetail.priority)
      // };

      // var { data } = await webapi.post(`${APIEndpointWeb.PostSignaturebyProvider}`, datax,
      //   {
      //     headers: { Authorization: `Bearer ${accessToken}` },
      //   }
      // );
      // setBase64OfSign(data.result.data ? data.result.data : "")
      getPostListPphoMember()
    } catch (error) {
      // console.log(error)
      // setLoading(false);
      // setBase64OfSign('')
    }
    //  finally {
    //    setLoading(false);
    //  }
  };



  const getSignatureByProviderTwo = async () => {
    try {
       setLoading(true);
      var datax = {
        account_id: localStorageData.data.account_id,
        cid: localStorageData.data.full_cid,
        priority: Number(resultDetail.priority)
      };

      var { data } = await webapi.post(`${APIEndpointWeb.PostSignaturebyProvider}`, datax,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      setBase64OfSign(data.result.data ? data.result.data : "")
    } catch (error) {
      console.log(error)
      setLoading(false);
      setBase64OfSign('')
    }
     finally {
       setLoading(false);
     }
  };


  const getPostListPphoMember = async () => {
    try {
      let datax = {
        document_no: resultDetail.document_no,
      };

      var { data } = await webapi.post(`${APIEndpointWeb.PostListPphoMember}`, datax,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      // console.log(APIEndpointWeb.PostListPphoMember, data)
      setOptionsPPHOMember(data.result && data.result.length > 0 ? data.result : [])
    } catch (error) {
      console.log(error)
      // setBase64OfSign('')
    } finally {
      setLoading(false);
    }
  };

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);
  const handleOpenPrefix = useCallback(() => setOpenPrefix(true), []);
  const handleClosePrefix = useCallback(() => setOpenPrefix(false), []);

  const handleOpenSecondDialog = () => {
    setOpenSecondDialog(true);
  };

  const handleChangeSelectDoc = (event: SelectChangeEvent) => {
    setSelectDoc(event.target.value as string);
    var xml = arrrayOfPdf.find(
      (element) => element.type === event.target.value
    );
    if (xml) {
      setvaluePdf(xml);
    }
  };
  const convertFileToBase64 = (file: any) => {
    return new Promise((resolve) => {
      let baseURL: any;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };




  const uploadPDF = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const files = e.target.files;
      if (!files || files.length === 0) return;

      let fileArray = Array.from(files);

      // Limit to 5 files
      if (fileArray.length + selectedFiles.length > 5) {
        Swal.fire({
          title: "เลือกไฟล์มากเกินไป",
          text: "สามารถเลือกได้สูงสุด 5 ไฟล์เท่านั้น",
          icon: "warning",
        });
        return false;
      }

      // Validate file type and size
      fileArray = fileArray.filter((file) => {
        if (file.type !== "application/pdf") {
          Swal.fire({
            title: "ไฟล์ไม่ถูกต้อง",
            text: `ไฟล์ "${file.name}" ไม่ใช่ PDF`,
            icon: "error",
          });
          return false;
        }

        if (file.size > 2 * 1024 * 1024) {
          Swal.fire({
            title: "ไฟล์ใหญ่เกินไป",
            text: `ไฟล์ "${file.name}" มีขนาดเกิน 2MB`,
            icon: "error",
          });
          return false;
        }

        return true;
      });

      if (fileArray.length === 0) {
        return false;
      }
      // var jsonParseOFselectedFiles: File[] = []
      var jsonBase64: FileBase64[] = [];
      selectedFiles.map(async (data) => {
        jsonBase64.push(data);
      });
      //  fileArray.map(async (data) =>  {
      //     // jsonParseOFselectedFiles.push(data)
      //     // let base64 = await convertFileToBase64(data)
      //     let filebase64 : FileBase64 =  {name: data.name, base64: "base64"}
      //     jsonBase64.push(filebase64)
      // })
      for (var xml in fileArray) {
        try {
          let base64 = await convertFileToBase64(fileArray[xml]);
          let filebase64: FileBase64 = {
            name: fileArray[xml].name,
            base64: base64,
          };
          jsonBase64.push(filebase64);
        } catch (error) {
          console.log("error", error);
        }
      }

      // console.log("jsonParseOFselectedFiles", jsonBase64);
      setSelectedFiles(jsonBase64);
      // Convert files to base64
      // const base64Files = await Promise.all(fileArray.map(getBase64File));
      // console.log("Uploaded PDFs:", base64Files);
    } catch (error) {
      console.error("File upload error:", error);
    } finally {
      e.target.value = ""; // Reset input field
    }
  };


  const HoverIconButton = styled(IconButton)({
    backgroundColor: "transparent",
    borderRadius: 3,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      // Change background on hover
    },
  });

  const findArraySelete = (value: string): string => {
    const xml = arrrayOfSelete.find((element) => element.value === value);

    if (xml) {

      if (xml.name === "register") {
        return "ใบสมัครเข้าร่วมตามนโยบาย “๓๐ บาทรักษาทุกที่ ด้วยบัตรประชาชนใบเดียว” ของหน่วยบริการเอกชน";
      } else {
        return "เอกสารข้อตกลงการแบ่งปันข้อมูลส่วนบุคคล (DSA)";
      }
    }

    return "";
  };

  const onDocumentLoadSuccess = (numPages: any) => {
    // console.log(numPages._pdfInfo.numPages)
    setErrorPDF("");
    setTotalPage(numPages._pdfInfo.numPages);
    setPageNumber(1);
    setScale(scaleForReset);
  };

  const onLoadError = (error: Error) => {
    console.error("Error while loading document:", error);
    setTotalPage(1);
    setPageNumber(1);
    setErrorPDF("There was an error loading the PDF document.");
  };



  return (
    <Box sx={{ height: "100%" }}>
      <LoadingIndicator open={loading} />
      <Grid item xs={12} md={12} lg={12}>
        <Box
          sx={{
            borderRadius: "15px",
            width: "100%",
            backgroundColor: "#ffffff",
            p: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            <Link href={checkPage234 === "2" ? "/pending-document" : checkPage234 === "3" ? "/admin-page-document" : "/public-health" } underline="none">
              <NavigateBeforeIcon
                sx={{
                  fontSize: 30,
                  color: "#024F80",
                  ml: 1,
                  cursor: "pointer",
                  mr: 1,
                  mt: 2,
                }}
              />
            </Link>
            <Box>
              <Typography
                variant="h5"
                sx={{
                  fontSize: "18px",
                  mt: 2,
                  color: "#024F80",
                  fontWeight: 600,
                }}
              >
                เอกสารข้อตกลงการแบ่งปันข้อมูลส่วนบุคคล (DSA/NDA)
              </Typography>
              <Box
                sx={{
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  mt: 1,
                  mb: 2,
                }}
              >
                <img
                  src={icon_hospital}
                  alt="icon_hospital"
                  style={{
                    width: "15px",
                    height: "15px",
                  }}
                />
                <Grid container>
                  <Grid item>
                    <Typography sx={{ ml: 1, mr: 1 }}>สถานพยาบาล :</Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ color: "#989898" }}>
                      {resultDetail.hname ? resultDetail.hname : '-'}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
          <Grid container sx={{ pl: 2, pr: 2, pb: 2 }} spacing={3}>
            <Grid item xs={12} md={12} lg={6} xl={7}>
              <Box
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#ffffff",
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    padding: 3,
                    backgroundColor: "#F0F3F6",
                    borderRadius: 3,
                  }}
                >
                  <Grid
                    container
                    spacing={1}
                    sx={{ alignItems: "center", mb: 2 }}
                  >
                    <Grid item xs={1} md={1}>
                      <img src={icon_doc} alt="icon_doc" width="30px" />
                    </Grid>
                    <Grid item xs>
                      <Typography>Document Preview</Typography>
                    </Grid>
                    <Grid
                      xs={12}
                      md={12}
                      lg={12}
                      xl={7}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Select
                        size="small"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectDoc}
                        onChange={handleChangeSelectDoc}
                        renderValue={(selected) => (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <DescriptionIcon fontSize="small" />
                            <Typography
                              sx={{
                                fontSize: "14px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {findArraySelete(selected)}
                            </Typography>
                          </Box>
                        )}
                        sx={{
                          fontSize: "12px", // ขนาดฟอนต์ของ Select
                          width: "100%",
                          borderRadius: "20px",
                          backgroundColor: "#0077CC",
                          color: "#ffffff",
                          "& .MuiSelect-select": {
                            padding: "6px 8px",
                            display: "flex",
                            alignItems: "center",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            fontSize: "10px", // ปรับขนาดฟอนต์ตอนแสดงผล
                          },
                          "& .MuiSelect-icon": {
                            color: "#ffffff",
                          },
                        }}
                      >        
                       {arrrayOfSelete.map((value, index) => (
                        <MenuItem key={index} value={value.value}>
                          <ListItemIcon>
                            <DescriptionIcon fontSize="small" />
                          </ListItemIcon>
                          <Typography sx={{ fontSize: "12px" }}>
                            {value.name === "register" ? "ใบสมัครเข้าร่วมตามนโยบาย “๓๐ บาทรักษาทุกที่ ด้วยบัตรประชาชนใบเดียว” ของหน่วยบริการเอกชน" : "เอกสารข้อตกลงการแบ่งปันข้อมูลส่วนบุคคล (DSA)"}
                          </Typography>{" "}
                          {/* แสดงข้อความเต็ม */}
                        </MenuItem>
                      ))}
                      </Select>
                    </Grid>
                  </Grid>

                  <Box
                    ref={viewerRef}
                    style={{
                      overflow: "auto",
                      width: "100%",
                      height: "100vh",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    {errorPDF ? (
                      <ErroPagerPDF />
                    ) : valuePdf.pdf_base64 ? (
                      <Document
                        file={`data:application/pdf;base64,${valuePdf.pdf_base64}`}
                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={onLoadError}
                      >
                        <Page
                          width={
                            window.screen.width > 1000
                              ? 1000
                              : window.screen.width - 20
                          }
                          pageNumber={pageNumber}
                          scale={scale}
                        />
                      </Document>
                    ) : (
                      ""
                    )}
                  </Box>
                  <Grid sx={{ display: "flex", justifyContent: "center" }}>
                    <Grid
                      container
                      xs="auto"
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#323639",
                        padding: 0.5,
                        borderRadius: 2,
                        mt: 2,
                        gap: 1,
                      }}
                    >
                      <Grid item>
                        <HoverIconButton
                          aria-label="delete"
                          sx={{ color: "#ffffff" }}
                          size="medium"
                          onClick={() =>
                            pageNumber > 1
                              ? setPageNumber(pageNumber - 1)
                              : setPageNumber(1)
                          }
                        >
                          <ArrowBackIosIcon fontSize="small" />
                        </HoverIconButton>
                      </Grid>
                      <Grid item>
                        <Typography sx={{ color: "#ffffff" }}>
                          {pageNumber}/{totalPage}
                        </Typography>
                      </Grid>

                      <Grid item>
                        <HoverIconButton
                          aria-label="delete"
                          sx={{ color: "#ffffff" }}
                          size="medium"
                          onClick={() =>
                            pageNumber < totalPage
                              ? setPageNumber(pageNumber + 1)
                              : setPageNumber(totalPage)
                          }
                        >
                          <ArrowForwardIosIcon fontSize="small" />
                        </HoverIconButton>
                      </Grid>
                      <Grid item>
                        <Divider
                          sx={{
                            color: "#ffffff",
                            borderColor: "#ffffff",
                            borderWidth: "1px",
                            height: "30px",
                          }}
                          orientation="vertical"
                          flexItem
                        />
                      </Grid>
                      <Grid item>
                        <HoverIconButton aria-label="zoom-in" size="medium">
                          <ZoomInIcon
                            fontSize="medium"
                            sx={{ color: "#ffffff" }}
                            onClick={() =>
                              setScale((prevScale: number) => prevScale + 0.2)
                            }
                          />
                        </HoverIconButton>
                        <HoverIconButton aria-label="delete" size="medium">
                          <ZoomOutIcon
                            fontSize="medium"
                            sx={{ color: "#ffffff" }}
                            onClick={() =>
                              setScale((prevScale: number) =>
                                Math.max(prevScale - 0.2, 0.5)
                              )
                            }
                          />
                        </HoverIconButton>
                      </Grid>
                    </Grid>

                  </Grid>

                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={12} lg={6} xl={5}>
              <Box
                sx={{
                  backgroundColor: "#f5fdff",
                  height: "100%",
                  borderRadius: 3,
                  border: "1px solid #dfebf7",
                }}
              >
                <Grid sx={{ padding: 2 }}>
                  <DetailDocPending
                    getSignatureByProviderTwo={getSignatureByProviderTwo}
                    arrrayOfPdf={arrrayOfPdf}
                    checkReject={checkReject}
                    optionsPPHOMember={optionsPPHOMember}
                    localStorageOrganization={localStorageOrganization}
                    localStorageData={localStorageData}
                    setLoading={setLoading}
                    getBase64OfSign={base64OfSign}
                    resultDetail={resultDetail}
                    loading={loading}
                    valuePdf={valuePdf.pdf_base64}
                    selectDoc={selectDoc} />

                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {/* <DialogAttachDocPDF
          getFilesPDF={getFilesPDF}
          dataPageForm={dataPageForm}
          setOpenAttachDoc={setOpenAttachDoc}
          openAttachDoc={openAttachDoc}
          setLoading={setLoading}
          fileslength={getFiles.length}
        /> */}
        {/* <SignSignatureDialog
          prefixValue={selectedValue}
          nameValue={nameData}
          cidValue={cid}
          dataPageForm={dataPageForm}
          getFiles={getFiles}
          getBase64OfSign={base64OfSign}
          setLoading={setLoading}
          setOpenSecondDialog={setOpenSecondDialog}
          openSecondDialog={openSecondDialog}
        /> */}
        {/* <SignatureDrawing /> modal วาดลายเซ็น */}
      </Grid>
    </Box>
  );
};

export default IndexPendingDocument;
